import useSessionStorage from './useSessionStorage';

/**
 * Tracks if a transaction is currently in progress
 * @returns {boolean} transaction initiated
 */
function useTransactionInitiated() {
  const [transactionInitiated, setTransactionInitiated] = useSessionStorage('transactionInitiated');
  return {transactionInitiated, setTransactionInitiated};
};

export default useTransactionInitiated;
